import camelcaseKeys, { type CamelCaseKeys } from 'camelcase-keys';

export type CamelCased<T> = CamelCaseKeys<T, true, false, true>;

export const camelCase = <T extends {}>(obj: T): CamelCased<T> => {
    return camelcaseKeys(obj, { deep: true, preserveConsecutiveUppercase: true });
};
